var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmiratesFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_603_8868)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 150,
    r: 150,
    fill: "#E30A17"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_603_8868)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M597 -17H-73V318H597V-17Z",
    fill: "#00732F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597 94.6666H-73V318H597V94.6666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597 206.333H-73V318H597V206.333Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5 -17H-73V318H94.5V-17Z",
    fill: "#FF0000"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_603_8868"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 300,
    rx: 150,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_603_8868"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 670,
    height: 335,
    fill: "white",
    transform: "translate(-73 -17)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmiratesFlag);
export default __webpack_public_path__ + "static/media/emirates-flag.1bb0a52a9fab3d66382102f2761a1a7a.svg";
export { ForwardRef as ReactComponent };